enum ImportClickableTextEnum {
    Employee,
    Tab

}

export { ImportClickableTextEnum };
